import dayjs from 'dayjs'

export const formatLondonTime = (date: dayjs.ConfigType, format: string) =>
  dayjs.utc(date).tz('Europe/London').format(format)

export const curriedUrlChanger = (base: string) => (path: string) => {
  const join = path[0] === '/' ? '' : '/'
  const url = new URL(`${base}${join}${path}`, window.location.origin)

  if (url.href === window.location.href) {
    return
  }

  window.history.pushState({}, '', url)
}
